import { useEffect } from "react";
import { Grid } from "@mui/material";
import {
  AutocompleteInput,
  maxValue,
  minValue,
  number,
  NumberInput,
  ReferenceInput,
  required,
  SelectInput,
  TextInput,
  useRecordContext,
} from "react-admin";
import { format1Decimal } from "../../CandidatesSettings/GradingScales/utils";
import CurriculumPdfDocument from "./components/CurriculumPdfDocument";
import { administrationRequests } from "api/administrationApi";

// Collections moved to the details page, each with its own endpoint.
const SaveForm = ({ setPdfDocumentId }) => {
  const record = useRecordContext();

  useEffect(() => {
    if (record?.pdfDocumentId) {
      setPdfDocumentId(record.pdfDocumentId);
    }
  }, [record?.pdfDocumentId, setPdfDocumentId]);

  return (
    <>
      <Grid
        container
        spacing={1}
      >
        <Grid
          item
          md={12}
          sm={6}
          xs={12}
        >
          <TextInput
            label="Заглавие"
            source="name"
            validate={required()}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <ReferenceInput
            source="degreeId"
            reference={administrationRequests.getDegreesSelect()}
          >
            <SelectInput
              label="Квалификационна степен"
              validate={[required()]}
            />
          </ReferenceInput>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <ReferenceInput
            source="specialityId"
            reference={administrationRequests.getSpecialitiesSelect()}
            filter={{ filterByUser: true }}
          >
            <AutocompleteInput
              label="Специалност"
              validate={[required()]}
              filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
            />
          </ReferenceInput>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <ReferenceInput
            source="studyTypeId"
            reference={administrationRequests.getStudyTypesSelect()}
            filter={{ filterByUser: true }}
          >
            <SelectInput
              label="Вид обучение"
              validate={[required()]}
            />
          </ReferenceInput>
        </Grid>
        <Grid
          item
          xs={12}
          md={2.3}
          sm={6}
        >
          <NumberInput
            label="Влиза в сила от"
            source="validFrom"
            type="number"
            min={1940}
            max={2999}
            step={1}
            validate={[required(), minValue(1940), maxValue(2999), number()]}
            onWheel={e => e.target.blur()}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={2}
        >
          <NumberInput
            label="Срок на обучение"
            source="yearsOfStudy"
            validate={[required()]}
            format={format1Decimal}
            onWheel={e => e.target.blur()}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <ReferenceInput
            source="admissionAfterEducationLevelId"
            reference={administrationRequests.getAdmissionAfterEducationLevelsSelect()}
          >
            <SelectInput label="Прием след" />
          </ReferenceInput>
        </Grid>
      </Grid>

      <CurriculumPdfDocument
        started
        setPdfDocumentId={setPdfDocumentId}
      />
    </>
  );
};

export default SaveForm;
